const t = "right-start", o = "right-end", n = "left-start", r = "left-end", s = "bottom-start", e = "bottom-end", a = "top-start", c = "top-end";
export {
  e as bottomEnd,
  s as bottomStart,
  r as leftEnd,
  n as leftStart,
  o as rightEnd,
  t as rightStart,
  c as topEnd,
  a as topStart
};
//# sourceMappingURL=design-system.es294.js.map
